import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const SolveProblemsHealthcare = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '25px',
        },
      },
    ],
  };

  return (
    <>
      <style>
        {`
              .solve-problems .slick-track {
                display:flex;
                margin:0
              }
              .solve-problems .slick-slide {
                width:33%;
                margin-right:5px
              }
              .solve-problems .slick-slide {
                outline: none
              }
              .solve-problems .slick-slide div {
                 outline: none
              }
              .solve-problems .slick-slide:focus,.slick-slide a {
                outline: none;
              }
              .shadow-new {
                box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                border-radius: 0px 0px 25px 25px;
              }
              .shadow-new-w {
                box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
              }
              .custom-dots {
                display:flex!important;
                justify-content:center;
              }
              .custom-dots li {
                position:relative;
                margin:0 3px;
                margin-top:20px;
                width:50px;
                height:2px;
                background-color: #C4C4C4; 
                overflow:hidden;
              }
              .custom-dots li.slick-active {
                background-color:#670F7A;
              }
              .custom-dots li button {
                position:absolute;
                width:100%;
                height:100%;
                top:0;
                left:0;
                opacity:0;
              }
              .slick-list:first-of-type,for-hover:first-of-type {
                padding-left:0!important;
              }
        `}
      </style>

      <Slider ref={slider} {...settings} className="solve-problems relative z-10 pt-24  ">
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-gray-slideOne px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Set Apart Your Brand</h3>
            <div className={'pr-0 md:pr-30'}>
              <p className={'mt-10'}>
                Healthcare companies can use explainer videos to distinguish themselves from competitors by spotlighting their offers. Well-made
                clinical animation can help businesses stand out in a crowded marketplace.
              </p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 px-0 md:px-15'}>
          <div className={'bg-red-slideTwo px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Promote Product or Service</h3>
            <div className={'mt-10'}>
              <p className={'mt-10'}>
                Trust is fundamental for healthcare businesses. It can be achieved by promoting a product or service well. Medical animations,
                illustrations, or live-action videos will highlight the benefits of your medical products and services, engaging potential patients.
              </p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 pl-0 md:pl-15'}>
          <div className="bg-blue-slideTree px-18 py-12  min-h-340 md:min-h-280">
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Educate and Engage</h3>
            <p className={'mt-10'}>
              Explainer videos help educate patients about treatment options, medical products, and healthcare processes. By engagingly providing
              simplified information, healthcare businesses can authorise patients and get better results and customer satisfaction.
            </p>
          </div>
        </div>
      </Slider>
    </>
  );
};
export default SolveProblemsHealthcare;
